import CryptoJS from 'crypto-js';

// 约定的密钥（16位字符串，AES-128）和偏移量（16位）
const SECRET_KEY = CryptoJS.enc.Utf8.parse('miuta-ai-1234567');
const IV = CryptoJS.enc.Utf8.parse('miuta-ai-1234-iv');

/**
 * 加密
 * @param {Object} data 需加密的参数（如{name: 'xxx', age: 'xxx'}）
 * @returns 加密并编码后的字符串
 */
export const encryptParams = <T>(data: T) => {
  // 将对象转为JSON字符串
  const jsonStr = JSON.stringify(data);
  // AES加密（CBC模式，Pkcs7填充）
  const encrypted = CryptoJS.AES.encrypt(jsonStr, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  // 加密结果转为字符串并编码（避免URL特殊字符问题）
  return encodeURIComponent(encrypted.toString());
};

/**
 * 解密
 * @param encryptedStr 加密并编码后的字符串（从URL获取）
 * @returns 解密后的原始参数对象（如{plan: 'xxx', success: 'xxx'}）
 */
export const decryptParams = <T>(encryptedStr: string): T | null => {
  try {
    // 先解码（对应加密时的encodeURIComponent）
    const decodedStr = decodeURIComponent(encryptedStr);
    // AES解密（使用与加密相同的模式和填充方式）
    const decrypted = CryptoJS.AES.decrypt(decodedStr, SECRET_KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    // 将解密结果转为JSON字符串，再解析为对象
    const jsonStr = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonStr);
  } catch (error) {
    console.error('解密失败：', error);
    return null; // 解密失败时返回null，避免程序崩溃
  }
};